<template>
	<div class="content flex flex-align-start">
		<div class="flex-1 mr40">
			<div style="margin-top: 10px;width: 600px;">
				<el-input placeholder="请输入单位名称" v-model="desc" class="input-with-select" @keyup.enter.native="search()">
					<template slot="prepend">单位名称</template>
				    <el-button slot="append" icon="el-icon-search" :loading="loading" @click="search()"></el-button>
				</el-input>
			</div>
			
			<div class="mt30" v-if="isReady && tableHeader.length">
				<!-- table -->
				<el-table :data="list" v-loading="isLoading" border style="width: 100%" :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#000000', fontSize: '16px',textAlign: 'center' }">
				    <el-table-column :prop="'col' + index" :label="item" :width="item == '单位名称'?'200':''" v-for="(item,index) in tableHeader" :key="index">
						<template #default="scope">
							<!-- 直接通过容器样式控制对齐 -->
							<div :style="{ 
								'text-align': item.trim() === '单位名称' ? 'center' : 'left',
								width: '100%' 
							}">
									{{ scope.row['col' + index] }}
							</div>
						</template>
					</el-table-column>
					
					<!-- 暂无数据 -->
					<template #empty>
						<el-empty description="暂无数据" :image-size="120"></el-empty>
					</template>
				</el-table>
				
				<!-- 分页 -->
				<div class="mt20" v-if="list.length">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizeArr" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
				</div>
			</div>
		</div>
		
		<!-- 宣传图 -->
		<div class="sticky" style="top: 200px;">
			<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
				<el-carousel-item v-for="(item,index) in swiper" :key="index">
					<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'CheckJob',
	data(){
		return{
			provinceList: [],
			province: '',
			types: [
				{ text: '专科', type: 'GW_ZK' },
				{ text: '本科及以上', type: 'GW_BK' },
			],
			positions: [
				{ text: '公务员国考', type: '0' },
				{ text: '公务员省考', type: '1' },
			],
			radio: 1,
			position: 0,
			desc: '',
			
			loading: false,  // 搜索按钮loading
			tableHeader: [],  // 表头
			list: []
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		this.getProvince()
	},
	methods: {
		async getProvince(){
			this.$http.get('/api/webs/search/dxxdsProvince')
			    .then(response => {
			        let res = response.data
					this.isReady = true
					if(res!=null){
						this.provinceList = res.list
					}
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},

		search(){
			if(!this.token) return EventBus.$emit('show-login', true)
			if(!this.desc) return this.$message({ message: '请输入专业名称', type: 'warning' })
			this.loading = true
			this.isReady = false
			this.list = []
			
			this.getData()
		},
		
		handleSizeChange(val) {
			this.page_size = val
			this.isLoading = true
			this.getData()
		},
		handleCurrentChange(val) {
			this.page = val
			this.isLoading = true
			this.getData()
		},
		
		async getData(){
			let params = {
				pageNum: this.page,
				pageSize: this.page_size,
				type: 'DW',
				nameLike: this.desc
			}
			this.$http.get('/api/webs/search/cdw', { params })
			    .then(response => {
			        let res = response.data
			        this.loading = false
			        this.isLoading = false
			        this.isReady = true
			        
			        this.totalCount = res.total
			        this.tableHeader = res.data.header
			        this.list = res.list
			    })
			    .catch(error => {
			        console.error(error)
					this.loading = false
					this.isLoading = false
			    })
		}
	}
}
</script>

<style scoped>
.el-form-item{
	margin-bottom: 0 !important;
}
.el-input--suffix{
	width: 110px !important;
}
</style>